import React from 'react';
import { Locale } from '../../../../localization/LocalizationKeys';
import DateDisplay from '../../../components/Badge/DateDisplay';
import { siteFieldConfig } from '../../person/fields/utils/personFieldsUtils';
import { PermissionEnum, SiteCriteriaOrder } from '../../../../gql/typings';


export const siteValidatedFieldConfig = siteFieldConfig(
  'validated',
  ['imfVt'],
  ({ localization }) => ({
    permission: PermissionEnum.VALIDATE_RECORD,
    title: localization.formatMessage(Locale.Attribute.Validated),
    additionalTableConfig: {
      width: 125
    },
    sorting: {
      ascend: SiteCriteriaOrder.IMF_VT_ASC,
      descend: SiteCriteriaOrder.IMF_VT_DESC,
    },
    render: (record) => <DateDisplay>{record?.imfVt}</DateDisplay>,
  })
);

